import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Monesto = ({ userType, monestoToken, monestoUrl }) => {
  const iframeLoaded = useRef(false);
  const iframeRef = useRef();

  const sendToIframeMonesto = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'SET_TOKEN',
          token: monestoToken,
          tokenUserType: userType,
        },
        `${monestoUrl}/${userType}`
      );
    }
  };

  const IframeWithScopeMonesto = () => {
    const url = new URL(`${monestoUrl}/${userType}`);
    url.searchParams.append('scope', window.location.origin);
    const iframeUrl = url.toString();

    const handleIframeLoad = () => {
      iframeLoaded.current = true;
      if (monestoToken) {
        sendToIframeMonesto();
      }
    };

    return (
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        onLoad={handleIframeLoad}
        style={{
          height: 'calc(100% - 18px)',
          width: 'calc(100% - 5px)',
          border: 'none',
          borderRadius: '8px',
          margin: '5px 5px 5px 0',
        }}
        sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation'
        allow='clipboard-write; clipboard-read'
      />
    );
  };

  return <div className='content'>{IframeWithScopeMonesto()}</div>;
};

Monesto.propTypes = {
  userType: PropTypes.string,
  monestoToken: PropTypes.string,
  monestoUrl: PropTypes.string,
};

export default Monesto;
